<template>
  <div class="c-final-riddle" ref="finalRiddle">
    <div class="c-inari c-final-riddle__inari" v-bind:class="{'c-inari--active': stage === 5}">
      <img :src="`${baseUrl}img/inari.svg`" alt="INARI">
    </div>
    <div class="c-final-riddle__lock">
      <img :src="`${baseUrl}img/lock.svg`" alt="">
    </div>
    <div class="c-final-riddle__wrap">
      <div class="c-final-riddle__inner">
        <h4>Now for the final riddle!</h4>
        <p>{{ questions[randomIndex].question }}</p>
        <form>
          <input type="number" v-model="finalAnswer" placeholder="Your Answer" min="0" />
          <button class="c-button c-button--primary c-button--thin" @click.prevent="submitFinal"><span v-if="!checkingAnswer">Submit</span><img :src="`${baseUrl}img/spinner.svg`" alt="Loading" v-if="checkingAnswer" width="30"></button>
          <div class="c-form__hint" v-show="finalAnswerError">HINT: {{ questions[randomIndex].hint }}</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'final-riddle',
  data() {
    return {
      finalAnswer: null,
      finalAnswerError: false,
      randomIndex: 0,
      checkingAnswer: false,
      questions: [
        {
          question: 'How many original Japanese castles still remain with an intact main tower?',
          answer: '12',
          hint: 'Between 10 and 15',
        },
        {
          question: 'Izumo Taisha Grand Shrine in Shimane Prefecture has been awarded how many stars by the Michelin Green Guide Japan?',
          answer: '2',
          hint: 'Between 1 and 5',
        },
        {
          question: 'Nachi Waterfall in Wakayama Prefecture is the tallest waterfall in Japan. How tall is it in metres?',
          answer: '133',
          hint: 'Between 130 and 135',
        },
        {
          question: 'What year will Japan host the Rugby World Cup?',
          answer: '2019',
          hint: 'Between 2018 and 2024',
        },
        {
          question: 'Several islands in the Seto Inland Sea including the art island of Naoshima host the contemporary arts festival ‘Setouchi Triennale’ every how many years?',
          answer: '3',
          hint: 'Between 1 and 5',
        },
        {
          question: 'On the famous Shikoku Henro pilgrimage walk, how many temples do you have the chance to explore?',
          answer: '88',
          hint: 'Between 85 and 90',
        },
        {
          question: 'How many prefectures are there in Japan?',
          answer: '47',
          hint: 'Between 45 and 50',
        },
        {
          question: 'How many major sumo tournaments are held in Japan every year?',
          answer: '6',
          hint: 'Between 5 and 10',
        },
        {
          question: 'What year will Tokyo next hold the Summer Olympic and Paralympic Games?',
          answer: '2020',
          hint: 'Between 2019 and 2030',
        },
        {
          question: 'How many UNESCO world heritage sites are there in Japan?',
          answer: '21',
          hint: 'Between 20 and 25',
        },
      ],
    };
  },
  computed: {
    stage: {
      get() { return this.$store.state.stage; },
      set(value) { this.$store.commit('setStage', value); },
    },
  },
  methods: {
    submitFinal() {
      this.checkingAnswer = true;

      setTimeout(() => {
        if (this.finalAnswer !== this.questions[this.randomIndex].answer) {
          this.finalAnswerError = true;
        } else {
          this.finalAnswerError = false;
          this.$ga.event('SecretScrolls', 'Click', 'Take Me There');
          this.stage = 6;
        }
        this.checkingAnswer = false;
      }, 500);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.randomIndex = Math.floor(Math.random() * this.questions.length);
    });
  },
};
</script>



// WEBPACK FOOTER //
// FinalRiddle.vue?a012154c